import MainList from './MainList';
export default MainList;
